import { Component, OnInit } from '@angular/core';
import { ViewChild, ElementRef } from '@angular/core';
import { BaseField } from '../../baseField';
declare let $: any;

@Component({
  selector: 'app-creditcard-date',
  templateUrl: './creditcard-date.component.html',
  styleUrls: ['./creditcard-date.component.scss']
})
export class CreditcardDateComponent extends BaseField implements OnInit {
  @ViewChild('ccDate') ccDateField: ElementRef;

  constructor() {
    super()
  }

  ngOnInit(): void {
    this.dateFormat();
  }

  dateFormat(){
    let input = this.formControlRef.value
    input = input.trim().replace(/[^\d]/g, "")
;   let year=input.slice(2);
    if (input.length >= 2){
        if (year.toString().length==4) {
          year =year.toString().slice(2,4);
        }
      let newInput = input.slice(0,2) + ' / ' + year;
      this.formControlRef.setValue(newInput);
    }
    if (input.length >= 4){
      this.validateMonth(input.slice(0,2));
      this.validateYear(+year);
    }

    var card_expiration = '';
    card_expiration += $('#card-expiration').val();
    $('.card-expiration-date div').html(card_expiration);
  }
  validateMonth(input:number){
    if(input > 12){
      this.formControlRef.setErrors({'Invalid format':true})
      this.fieldErrors[this.fieldObject.fieldName] = 'invalid Month'
    }else{
      this.fieldErrors[this.fieldObject.fieldName] = ''
    }
  }
  validateYear(input:number){
    let year = new Date().getFullYear() - 2000;
    if(input < year){
      this.formControlRef.setErrors({'Invalid format':true})
      this.fieldErrors[this.fieldObject.fieldName] = 'invalid year'
    }else{
      this.fieldErrors[this.fieldObject.fieldName] = ''
    }
  }
}
